import { dashboardTour } from "./dashboardTour";
import { registrationTour } from "./registrationTour";

export const tours = {
  registration: registrationTour,
  dashboard: dashboardTour
};